export default __webpack_public_path__ + "static/media/Bombardier Aerospace - Logo.28941c47.svg";